export var fallBackLogger = {
  noticeError: function noticeError(error, customAttributes) {
    if (process.env.NODE_ENV !== 'test') {
      return console.error({
        error: error,
        customAttributes: customAttributes
      });
    }
  },
  addPageAction: function addPageAction(actionName, attributes) {
    if (process.env.NODE_ENV !== 'test') {
      return console.error({
        actionName: actionName,
        attributes: attributes
      });
    }
  },
  setCustomAttribute: function setCustomAttribute(name, value) {
    return console.error({
      name: name,
      value: value
    });
  },
  setPageViewName: function setPageViewName(name, host) {
    return console.error({
      name: name,
      host: host
    });
  },
  setErrorHandler: function setErrorHandler() {
    return console.error('setNewRelicErrorHandler');
  }
};

// Returns either new relic instance from window object or fallback logger
var getNewRelicInstance = function getNewRelicInstance() {
  return (
    // we need to return fallBackLogger in case window.newRelic is unavailable
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    typeof window !== 'undefined' && window.newrelic ? window.newrelic : fallBackLogger
  );
};
export default getNewRelicInstance;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/observability/dist/esm/NewRelicHelpers/getNewRelicInstance.js
// module id = 595
// module chunks = 11